import styled from "styled-components";
import { ButtonContained, ButtonText, FontStyles } from "../../../components";

const Container = styled.div(({ theme, noLine }) => {
    return {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        backgroundColor: theme.palette.background.paper,
        padding: "16px 20px",
        paddingInline: noLine && 0,
        borderRadius: "5px",

        width: "100%",
        marginBottom: theme.spacing(1.5),
        height: "fit-content",
    };
});

const ContainerFilter = styled.div(({ theme, noLine }) => {
    return {
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        backgroundColor: theme.palette.background.paper,
        padding: "16px 20px",
        paddingInline: noLine && 0,
        borderRadius: "5px",

        width: "100%",
        marginBottom: theme.spacing(1.5),
        height: "fit-content",
    };
});

const PageNameContent = styled.div(({ theme }) => {
    return {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(0.75),
    };
});

const PageNameContainer = styled.div(({ theme }) => {
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexDirection: "row",
        backgroundColor: theme.palette.action.selected,
        padding: "16px 20px",
        borderRadius: "5px",

        width: "100%",
        marginBottom: theme.spacing(1.5),
        height: "fit-content",

        [theme.breakpoints.down("md")]: {
            flexDirection: "column",
            alignItems: "flex-end",
            gap: "8px",
        },
    };
});

const RegitryButton = styled(ButtonContained)(({ theme }) => {
    const { palette: colors, spacing } = theme;
    return {
        "&&.MuiButton-root": {
            backgroundColor:"white",
            color:"#272727",
            marginTop: 0,
            borderRadius: "20px",
            ...FontStyles.medium14,

            "&:hover": {
                backgroundColor: "#f0f0f0",
            },

            "& .MuiButton-label": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            },
        },
    };
});

const RegitryButtonSecond = styled(ButtonContained)(({ theme }) => {
    const { palette: colors, spacing } = theme;
    return {
        "&&.MuiButton-root": {
            color:" white",
            borderRadius: "20px",
            marginTop: 0,
            ...FontStyles.medium14,

            "& .MuiButton-label": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            },
        },
    };
});

const ButtonContainer = styled.div(({ theme }) => {
    return {
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        flexDirection: "row",
        gap: theme.spacing(1),
    };
});

const Submit = styled(ButtonContained)(({ theme }) => {
    return {
        "&&.MuiButton-root": {
            backgroundColor: theme.palette.action.selected,
            ...FontStyles.semibold12,
            paddingInline: theme.spacing(2.5),
            paddingBlock: theme.spacing(1.9),
        },
    };
});
const Clear = styled(ButtonText)(({ theme }) => {
    return {
        "&&.MuiButton-root": {
            color: theme.palette.action.selected,
            ...FontStyles.semibold12,
            paddingInline: theme.spacing(2.5),
            paddingBlock: theme.spacing(1.9),
        },
    };
});

const Visibility = styled.div(({ theme, $visibility }) => {
    const { palette: colors, spacing } = theme;
    return {
        backgroundColor:
            $visibility === "PRIVADO"||$visibility === "Privado"||$visibility === "PRIVATE"||$visibility === "Private" ? colors.background.paper : colors.primary.main,
        color:
            $visibility === "PRIVADO"||$visibility === "Privado"||$visibility === "PRIVATE"||$visibility === "Private" ? colors.primary.main : colors.background.paper,
        padding: spacing(1),
        border: "solid 3px",
        borderRadius: spacing(3),
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        gap: spacing(0.5),
        flex: 0.6,
        ...FontStyles.semibold12,
    };
});

const CancelButton = styled(ButtonText)(({ theme }) => {
    const { palette: colors, spacing } = theme;
    return {
        "&&.MuiButton-root": {
            marginTop: 0,
            ...FontStyles.medium14,
            color: colors.primary.main,
            paddingInline: spacing(2),
            "& .MuiButton-label": {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            },
        },
    };
});

const InfoName = styled.p(({ theme }) => {
    const { spacing } = theme;
    return {
        ...FontStyles.semibold14,
        textTransform: "uppercase",
        padding: 0,
        margin: 0,
        color: "#0C396D",
        transition: ".2s",
        pointerEvents: "none",
        alignItems: "center",
        display: "flex",
        overflow: "hidden",
        paddingTop: spacing(2.5),
    };
});
const InfoValueData = styled.p(({ theme }) => {
    const { spacing } = theme;
    return {
        ...FontStyles.semibold14,
        paddingBlock: spacing(1.25),
        color: "#272727",
        width: "100%",
        margin: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    };
});

const customLine = styled.div(({ theme }) => {
    const { spacing } = theme;
    return {
        width: "100%",
        height: "0.2rem",
        backgroundColor: "#313437",
        border: "none",
        marginTop: spacing(4),
        marginBottom: spacing(3),
    };
});

const backgroundGrids = styled.div(({ theme }) => ({
    backgroundColor: "#E9E9E9",
    borderRadius: "5px",
    opacity: "1",
    paddingLeft: "20px",
    paddingRight: "33px",
    paddingBottom: "18px",
}));

const containerTags = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    marginTop: "5px",
}))

const tags = styled.div(({ theme }) => ({
    backgroundColor: "#24272A",
    borderRadius: "14px",
    opacity: 1,
    color: "#FFFFFF",
    fontSize: "14px",
    padding: "5px 10px",
    width: "fit-content",
}));

const Styles = {
    Container,
    ContainerFilter,
    PageNameContent,
    PageNameContainer,
    RegitryButton,
    RegitryButtonSecond,
    ButtonContainer,
    Clear,
    Submit,
    Visibility,
    CancelButton,
    InfoName,
    InfoValueData,
    customLine,
    backgroundGrids,
    tags,
    containerTags,
};

export default Styles;
